import React, { Component, Fragment } from 'react';
import { AppProvider } from './App.Store';
import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import Candidates from '../Candidates/Candidates';
import Popup from '../Popup/Popup';

export default class App extends Component {
  render() {
    return (
      <Fragment>
      <AppProvider>
        <Popup />
        <header>
          <div id="bananas">
            <div className="bananabanner">
              <iframe title="Banana" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" allowtransparency="true" src="https://z.ynet.co.il/short/commerce/2015/links/header/Default.aspx"></iframe>
            </div>
          </div>
        </header>
        <div className="App">
          <Header />
          <Candidates />
          <Footer />
        </div>
            </AppProvider>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx